import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import FrameStep1 from './FrameStep1'
import FrameStep2 from './FrameStep2'

function FrameClaimForm(props) {
  const { visionInsuranceClaimForm, activeTab, claimFormTemplate, submitEyeMedClaimForm } = props

  return (
    <div className='row mb-5'>
      <div className='col-10'>
        <div className='bg-white p-6 border rounded'>
          {activeTab == 2 && <FrameStep1
            visionInsuranceClaimForm={visionInsuranceClaimForm}
          />}
          {activeTab == 3 && <FrameStep2
            visionInsuranceClaimForm={visionInsuranceClaimForm}
            claimFormTemplate={claimFormTemplate}
            submitEyeMedClaimForm={submitEyeMedClaimForm}
          />}
        </div>
      </div>
      <div className='col-2'>
        <div className='bg-white border rounded-lg'>
          <div className='d-flex flex-column align-items-center'>
            <span className='py-5 px-6 w-100 text-primary'>Frame</span>
          </div>
        </div>
      </div>
    </div>
  )
}

// const mapStateToProps = (state) => {
//   const { visionInsuranceClaimForm } = state
//   return {
//     frameOptions: visionInsuranceClaimForm.frameOptions,
//   }
// }

export default connect()(FrameClaimForm)